<script>
export default {
	lang: 'shop',
}
</script>

<template>
	<CheckoutStepLayout :title="$lang('Iniciando proceso de compra')" />
</template>
